/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FollowSearchButton_favoritesConnection$ref: FragmentReference;
export type FollowSearchButton_favoritesConnection = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +serviceId: ?string
    |}
  |}>,
  +$refType: FollowSearchButton_favoritesConnection$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FollowSearchButton_favoritesConnection",
  "type": "favoritesConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "favoritesEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Favorite",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2f893cfa8da2b1adcbc4e57d7b3984ad';
module.exports = node;
